import * as model from "@/model/prd/qualityMgt/pelletizing/QualityResult";
import {
  newEntityStoreHelper
} from "@/store/common/entityModule";
import router from "@/router/index";


function newFilter(paginationFilter = {}) {
  var filter = Object.assign({}, paginationFilter, model.filter)
  return filter;
}


export default newEntityStoreHelper(() => new model.QualityResult(), newFilter)
  .withStates({
    idReport: 2,

    baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd",
    qualityDataStatus: '',
    qualityItemDetails: '',
    results: [],

  }) //TODO load at the application start   
  .withMutations({
    setQualityItemDetails(state, value) {
      state.qualityItemDetails = value
    },
    setResults(state, value) {
      state.results = value
    }
  })
  .withActions({
    display(context) {
      router.push('/prd/qualityResult/display');
      // context.dispatch("api/get", {
      //         url: context.state.baseModuleUrl + "/qualityResult/findAll"
      //     }, {
      //         root: true
      //     })
      //     .then(response => {

      //         {

      //             context.commit('qualityResult' + "/setRows", response, {
      //                 root: true
      //             });

      //         }
      //     });
      // context.dispatch("api/get", {
      //         url: context.state.baseModuleUrl + "/qualitySpecification/findAll"
      //     }, {
      //         root: true
      //     })
      //     .then(response => {

      //         {

      //             context.commit('qualitySpecification' + "/setRows", response, {
      //                 root: true
      //             });

      //         }
      //     });
      context.dispatch("api/get", {
        url: context.state.baseModuleUrl + "/qualityItem/findAll"
      }, {
        root: true
      })
        .then(response => {

          {

            context.commit('qualityItem' + "/setRows", response, {
              root: true
            });

          }
        });
    },

    qualityDataStatus(context, entity) {

      context.state.qualityDataStatus = entity;

    },
    getDetails(context, id) {


      context.dispatch("api/get", {
        url: context.state.baseModuleUrl + "/qualityData" + "/findById/" + id
      }, {
        root: true
      })
        .then(response => {
          {
            context.commit('qualityResult' + "/setRows", response.qualityResults, {
              root: true
            });

          }
        });
    },

    Check(context, entity) {
      context.dispatch("api/post", {
        url: context.state.baseModuleUrl + "/" + entity + "/check",
        data: context.state.entity,

      }, {
        root: true
      })
        .then(function () {
          context.dispatch("base/showSuccess", {
            userAlertSuccessStr: "Sucess!",
            dismissCountDown: 5,
            userAlertSuccessVisible: false,
          }, {
            root: true
          }).then(function () {
            context.dispatch("api/get", {
              url: context.state.baseModuleUrl + "/qualityData" + "/findById/" + context.state.qualityDataStatus.id
            }, {
              root: true
            })
              .then(response => {
                {
                  context.commit('qualityResult' + "/setRows", response.qualityResults, {
                    root: true
                  });
                  context.commit('qualityData' + "/setRows", {
                    response
                  }, {
                    root: true
                  });

                }
              });
          })
        });
    },
    getQualityItemDetails(context, code) {


      context.dispatch("api/get", {
        url: context.state.baseModuleUrl +
          "/qualityItemDetails/findByItemCode/" +
          code
      }, {
        root: true
      })
        .then(response => {

          {


            context.commit('qualityResult' + "/setQualityItemDetails", response, {
              root: true
            });

          }
        });
    },

    getResults(context, entity) {

      context
        .dispatch(
          "api/post",
          {
            url:
              context.state.baseModuleUrl + "/qualityResult" + "/findByResultFilter",
            data: entity
          },
          { root: true }
        )
        .then(response => {

          context.commit('qualityResult' + "/setResults", response.data, {
            root: true
          });


        })

    }
  })
  .buildStore()